import "../../../../content/utils/reactBnbGalleryStyle.css";
import ReactBnbGallery from "react-bnb-gallery";
import * as React from 'react';
export default {
  ReactBnbGallery,
  React
};